export const ASSETS = {
  LOGO: "/logo.png",
} as const;
